import { withRouter, Prompt } from "react-router";
import { Link, Switch, Route } from "react-router-dom";
import React, { Component } from "react";
import { CSSTransition } from "react-transition-group";
import { connect } from "react-redux";
import { updatePreference } from "../../actions/preference";
import { fetchEndpointIfNeeded as ftch, send } from "../../actions/fetch";
import { Formik } from "formik";
import NavItem from "../utilities/NavItem";
import NavContent from "../utilities/NavContent";
import FormButtonPanel from "../utilities/FormButtonPanel";
import JsonViewer from "../utilities/tabs/jsonViewer";
import moment from "moment";
import AceEditor from "react-ace";
import ReactJson from "react-json-view";
import "brace/mode/json";
import "brace/theme/github";
import _ from "lodash";
import { showMessage, closeMessage } from '../../actions/messageBox';
import {setLoader} from '../../actions/loader'
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_EYMIO_BASE_URL;

class PreferencesForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			endpoints: props.endpoints,
			resultStatus: "",
			resultTime: "",
			resultResponse: {},
			preferences: {},
			isLoading: false,
			timeZones: []
		};
	}

	breadCrumb() {
		let breadCrumb = window.location.href.split("/");
		return breadCrumb;
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			endpoints: nextProps.endpoints,
			ACLEndpointList: nextProps.ACLEndpointList,
			isFetching: nextProps.isFetching,
		});
	}

	getCurrentPreferences = () => {
		this.setState({
			isLoading: true
		});
		axios
			.get("/preferences?access_token=" + this.props.auth.access_token)
			.then((response) => {
				// handle success
				console.log(response);

				this.setState(
					(state) => {
						return Object.assign({}, state, {
							preferences:
								response && response.data && response.data[0],
							isLoading: false
						});
					},
					() => {
						// Save the export max limit to the local storage to be available anywhere
						localStorage.setItem(
							"export_max_limit",
							this.state.preferences.export_max_limit
						);
					}
				);
			})
			.catch( err =>{
				this.setState({
					isLoading: false
				});
			})
	};

	getTimezones = () => {
		this.setState({
			isLoading: true
		});
		axios
			.get("/timezones?access_token=" + this.props.auth.access_token)
			.then((response) => {
				// handle success

				this.setState(
					(state) => {
						return Object.assign({}, state, {
							timeZones:
								response && response.data,
							isLoading: false
						});
					},
					() => {
						
					}
				);
			})
			.catch( err =>{
				this.setState({
					isLoading: false
				});
			})
	};

	componentDidMount() {
		this.getCurrentPreferences();
		this.getTimezones();
	}

	handleBlur = (e) => {

		let { name, value } = e.target;

		if ((name == 'notification_start_at') || (name == 'archive_schedule')) {

			let vals = value.split(":")

			let val0 = vals[0].padStart(2, '0')

			if(!/^([0-1][0-9]|[2][0-3])$/.test(val0)) {

				val0 = "23"
			}

			let val1 = "59"

			if (vals[1]) {

				val1 = vals[1].padStart(2, '0')
			}
			
			if(!/^([0-5][0-9])$/.test(val1)) {

				val1 = "59"
			}

			value = val0 + ":" + val1
		}

		this.setState(
			(state) => {
				return Object.assign({}, state, {
					preferences: Object.assign({}, state.preferences, {
						[name]: value,
					}),
				});
			},
			() => {
				
			this.props.dispatch(setLoader(false))
				console.log("current preferences: ", this.state.preferences);
			}
		);
	};

	handleChange = (e) => {

		let { name, value } = e.target;

		if (
			(name == 'enable_notification') || 
			(name == 'include_extracted') || 
			(name == 'include_published')
		) {

			if (e.target.checked) {
				value = 1
			} else {
				value = 0
			}
		}

		//this.props.dispatch(setLoader(true))

		this.setState(
			(state) => {
				return Object.assign({}, state, {
					preferences: Object.assign({}, state.preferences, {
						[name]: value,
					}),
				});
			},
			() => {
				
			this.props.dispatch(setLoader(false))
				console.log("current preferences: ", this.state.preferences);
			}
		);
	};

	handleKeyDown = e => {

		let pos = e.target.selectionStart

		console.log(e.key)

		if (
			(e.key != "Backspace") &&
			(e.key != "Delete")  &&
			(e.key != "Control")
		   ) {

			if(pos == 2) {

				if(":".includes(e.key) === false) {

					e.preventDefault();
				}
			} else {
				if("0123456789".includes(e.key) === false) {

					e.preventDefault();
				}
			}
		}
	 }

	render() {
		let {
			isFetching,
			resultResponse,
			resultStatus,
			resultStatusText,
			resultOk,
			resultTime,
			timeZones
		} = this.state;

		// console.log("resultResponse",resultResponse)
		// console.log("resultStatus",resultStatus)
		// console.log("resultTime",resultTime)

		let { endpoints, dispatch, auth } = this.props;

		let timezoneObj = timeZones

		let sandboxTypeObj = [
			{
				name: "EYM",
				type: "eym",
				id: "1",
			},
			{
				name: "TRM",
				type: "trm",
				id: "2",
			},
			{
				name: "VOX",
				type: "vox",
				id: "3",
			},
			{
				name: "FNT",
				type: "fnt",
				id: "4",
			},
			{
				name: "OPIE",
				type: "opie",
				id: "5",
			},
			{
				name: "ETAX",
				type: "etax",
				id: "6",
			},
			{
				name: "CGN",
				type: "cgn",
				id: "7"
			},
			{
				name: "BESTPASS",
				type: "bsp",
				id: "8"
			}

		];

		let getPreferencesList;
		let getPreferenceName;

		for (let n in endpoints) {
			if (endpoints[n].name === "preferences") {
				getPreferencesList = endpoints[n].list;
				getPreferenceName = endpoints[n].name;
			}
		}

		let objProp = {};
		let initVal;
		let getPreferenceId;

		if (getPreferencesList) {
			let getPreferenceValues = getPreferencesList[0];
			getPreferenceId = getPreferenceValues && getPreferenceValues.id;
			initVal = Object.assign(
				{},
				{
					id: getPreferenceValues && getPreferenceValues.id,
					sandbox_type:
						getPreferenceValues && getPreferenceValues.sandbox_type,
					export_max_limit:
						getPreferenceValues &&
						getPreferenceValues.export_max_limit,
					time_zone:getPreferenceValues && getPreferenceValues.time_zone,
					from_email_address:getPreferenceValues && getPreferenceValues.from_email_address
					// time_format:getPreferenceValues && getPreferenceValues.time_format,
					// date_format:getPreferenceValues && getPreferenceValues.date_format,
				},
				objProp
			);
		}
		// else{
		//     initVal = Object.assign({}, {
		//         sandbox_type:"",
		//         time_zone:"",
		//         time_format:"",
		//         date_format:"",

		//     }, objProp)
		// }

		let getConnectionList;
		let getDatasourceList;

		let methods = ["POST", "GET", "PUT", "DELETE"];

		let bodyTabList = ["Body"];

		let preferenceTabList = ["General"];

		if(!this.state.isLoading){
			if(!this.props.isSaving){
				return(
					<div className="working-area-content">
					<div className="component-title list-group" id="working-area">
						<div className="list-group-item list-group-item-action gradient-background">
							<div className="" id="endpoint-label-wrapper">
								<div className="float-left breadcrumbs">
									<div className="">
										<p>
											<Link to={"/"}>
												<i className="fas fa-th"></i>
											</Link>
											<i className="fas fa-arrow-right"></i>
											<Link to={`/${this.breadCrumb()[3]}`}>
												Preferences
											</Link>
										</p>
									</div>
								</div>
							</div>
						</div>
	
						<Formik
							initialValues={initVal}
							validateOnChange={true}
							validateOnBlur={false}
							validate={(values) => {
								let errors = {};
								return errors;
							}}
							onSubmit={(values, actions) => {
								
								let endpointName = getPreferenceName;
	
								let accessToken = auth.access_token;
	
								let data = values;
							
								dispatch(setLoader(true))
								dispatch(

									updatePreference(
										getPreferenceId,
										endpointName,
										accessToken,
										this.state.preferences
									)
								)
									.then((response) => {
										if(response.ok){
											dispatch(setLoader(false))
											dispatch(
												showMessage({
												  type: "success",
												  title: "Success",
												  message: 'Preferences successfully saved.',
												  onClick: () => {
													window.location.reload();
												  }
												})
											);
										}else{
											dispatch(setLoader(false))
											dispatch(
												showMessage({
												  type: "error",
												  title: "",
												  message: `Unable to save. Please Contact
												  Administrator.`
												})
											  );
										}
									
									})
									.catch((error) => {
										dispatch(setLoader(false))
										dispatch(
											showMessage({
											  type: "error",
											  title: "",
											  message: `Unable to save. Please Contact
											  Administrator.`
											})
										  );
									});
							}}
							render={({
								handleSubmit,
								handleChange,
								setFieldValue,
								values,
								errors,
							}) => {
								let mainPaneFields = [];
								let methodsDetailsFields = [];
	
								let bodyKeycount = 0;
								let bodyTabCounter = 0;
								let bodyDetailsTabs = [];
								let bodyDetailsFields = [];
	
								let preferenceKeyCount = 0;
								let preferenceTabCounter = 0;
								let preferenceDetailsTabs = [];
								let preferenceDetailsFields = [];
	
								let generalView = (
									<div className="preference-wrapper">
										<div className="preference-section">
										<div className="general-content">
											<div className="preference-header">Threshold</div>	
												<div className="input-group-form">
												<label className="my-0"  style={{fontSize: "12px"}}>
													Export Max limit:{" "}
												</label>
												<select
													className="preferences-sandbox form-control"
													onChange={this.handleChange}
													name="export_max_limit"
													value={
														this.state.preferences
															.export_max_limit
													}
													id="preferences-export_max_limit"
												>
													<option value="10000">
														10,000
													</option>
													<option value="20000">
														20,000
													</option>
													<option value="50000">
														50,000
													</option>
													<option value="100000">
														100,000
													</option>
													<option value="-1">
													No Max Limit
													</option>
												</select>
												{errors.export_max_limit && (
													<div className="invalid-devtools">
														{errors.export_max_limit
															? errors.export_max_limit
															: ""}
													</div>
												)}											
																		
											</div>
											<div className="preference-header">Localization</div>
											<label className="my-0"  style={{fontSize: "12px"}}>
													Select Timezone:{" "}
												</label>
												<select
													type="text"
													name="time_zone"
													onChange={this.handleChange}
													value={
														this.state.preferences
															.time_zone
													}
													className="preferences-timezone form-control preferences-input-select"
													id="preferences-timezone"
												>
												<option
														key={0}
														value={0}
														className={""}
														disabled
													>
														Select Timezone 
													</option>
													{timezoneObj.map((stObj) => {
														return (
															<option
																key={stObj.id}
																value={stObj.id}
																className={""}
															>
																{stObj.offset_name.replace('(+', '(UTC+').replace('(-', '(UTC-').replace('(0', '(UTC+0')}
															</option>
														);
													})}
												</select>
												{errors.time_zone && (
													<div className="invalid-devtools">
														{errors.time_zone
															? errors.time_zone
															: ""}
													</div>
												)}
											<div className="preference-header">Formatting</div>
											{/* <div style={{width: '132px'}}> */}
												<label className="my-0"  style={{fontSize: "12px"}}>
													Input Time Format:{" "}
												</label>
												<input 
													type="text"
													name="time_format"
													onChange={this.handleChange}
													value={this.state.preferences.time_format}
													className="preferences-dateformat form-control preferences-input-select"
													id="preferences-dateformat"
												/>
												{errors.time_format && (
													<div className="invalid-devtools">
														{errors.time_format
															? errors.time_format
															: ""}
													</div>
												)}
												{/* </div> */}
												<label className="my-0"  style={{fontSize: "12px"}}>
													Input Date Format:{" "}
												</label>
												<input
													type="text"
													name="date_format"
													onChange={this.handleChange}
													value={this.state.preferences.date_format}
													className="preferences-dateformat form-control preferences-input-select"
													id="preferences-dateformat"
												/>
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.date_format
															: ""}
													</div>
												)}					
												<div className="preference-header">Data Retention</div>	
												<table width="100%">
												<tr>
												<td valign="top">
												<div className="input-group-form">
												<label className="my-0"  style={{fontSize: "12px"}}>
													Period:{" "}
												</label>
												<select
													className="preferences-retention_period form-control preferences-input-select"
													onChange={this.handleChange}
													name="retention_period"
													value={
														this.state.preferences
															.retention_period
													}
													id="preferences-retention_period"
												>
													<option value="1">
														1 Month
													</option>
													<option value="2">
														2 Months
													</option>
													<option value="3">
														3 Months
													</option>													
												</select>
												{errors.retention_period && (
													<div className="invalid-devtools">
														{errors.retention_period
															? errors.retention_period
															: ""}
													</div>
												)}					
												</div>
												</td>
												<td>
												<div className="input-group-form">
												<label className="my-0"  style={{fontSize: "12px"}}>
													Schedule (hh:mm):{" "}
												</label>
												<input
													type="text"
													name="archive_schedule"
													onChange={this.handleChange} 
													onBlur={this.handleBlur}
													value={this.state.preferences
															.archive_schedule}
													className="form-control preferences-input"
													id="preferences-archive_schedule"
													maxLength="5"
												/>
												{errors.archive_schedule && (
													<div className="invalid-devtools">
														{errors.archive_schedule
															? errors.archive_schedule
															: ""}
													</div>
												)}	
												</div>
												</td>
												</tr>
												</table>
												<br />
										</div>
										</div>
										<div className="preference-section-spacer">&nbsp;</div>
										<div className="preference-section">
												<div className="preference-header">Messages</div>
												<table width="100%">
												<tr>
												<td valign="top">
												<label className="my-0"  style={{fontSize: "12px"}}>
													Enable Notification:{" "}
												</label>
												<div className=" ">
												  <span className="my-0" style={{fontSize: "12px"}}>Off</span>
								                  <label className="switch" style={{marginLeft: "16px", marginRight: "8px"}}>
								                    <br />
								                    <input
								                      className="form-control"
								                      type="checkbox"
								                      name="enable_notification"
								                      id="preferences-enable_notification" 
													  onChange={this.handleChange}
													  value={this.state.preferences.enable_notification}
								                      checked={this.state.preferences.enable_notification && "checked"}
								                    />								                   
								                    <span className="slider round"></span>
								                  </label>
								                  <span className="my-0" style={{fontSize: "12px"}}>On</span>
								                </div>								
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.enable_notification
															: ""}
													</div>
												)}	
												<p style={{marginBottom: "-1rem"}}>&nbsp;</p>											
												<label className="my-0"  style={{fontSize: "12px"}}>
													From Email Address:{" "}
												</label>
												<input
													type="text"
													name="from_email_address"
													onChange={this.handleChange}
													value={this.state.preferences
															.from_email_address}
													className="form-control preferences-input"
													id="preferences-from_email_address"
												/>
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.from_email_address
															: ""}
													</div>
												)}
												<label className="my-0"  style={{fontSize: "12px"}}>
													To Email Address:{" "}
												</label>
												<input
													type="text"
													name="to_email_address"
													onChange={this.handleChange}
													value={this.state.preferences
															.to_email_address}
													className="form-control preferences-input"
													id="preferences-to_email_address"
												/>
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.to_email_address
															: ""}
													</div>
												)}
												<label className="my-0"  style={{fontSize: "12px"}}>
													Include Extracted:{" "}
												</label>
												<div className=" ">
												  <span className="my-0" style={{fontSize: "12px"}}>No</span>
								                  <label className="switch" style={{marginLeft: "16px", marginRight: "8px"}}>
								                    <br />
								                    <input
								                      className="form-control"
								                      type="checkbox"
								                      name="include_extracted"
								                      id="preferences-include_extracted" 
													  onChange={this.handleChange}
													  value={this.state.preferences.include_extracted}
								                      checked={this.state.preferences.include_extracted && "checked"}
								                    />								                   
								                    <span className="slider round"></span>
								                  </label>
								                  <span className="my-0" style={{fontSize: "12px"}}>Yes</span>
								                </div>								
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.include_extracted
															: ""}
													</div>
												)}	
												</td>
												<td valign="top">
												<label className="my-0"  style={{fontSize: "12px"}}>
													Notification Start At (hh:mm):{" "}
												</label>
												<input
													type="text"
													name="notification_start_at"
													onChange={this.handleChange} 
													onBlur={this.handleBlur}
													value={this.state.preferences
															.notification_start_at}
													className="form-control preferences-input"
													id="preferences-notification_start_at"
													maxLength="5"
												/>
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.notification_start_at
															: ""}
													</div>
												)}
												<label className="my-0"  style={{fontSize: "12px"}}>
													CC Email Address:{" "}
												</label>
												<input
													type="text"
													name="cc_email_address"
													onChange={this.handleChange}
													value={this.state.preferences
															.cc_email_address}
													className="form-control preferences-input"
													id="preferences-cc_email_address"
												/>
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.cc_email_address
															: ""}
													</div>
												)}
												<label className="my-0"  style={{fontSize: "12px"}}>
													Bcc Email Address:{" "}
												</label>
												<input
													type="text"
													name="bcc_email_address"
													onChange={this.handleChange}
													value={this.state.preferences
															.bcc_email_address}
													className="form-control preferences-input"
													id="preferences-bcc_email_address"
												/>
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.bcc_email_address
															: ""}
													</div>
												)}
												<label className="my-0"  style={{fontSize: "12px"}}>
													Include Published:{" "}
												</label>
												<div className=" ">
												  <span className="my-0" style={{fontSize: "12px"}}>No</span>
								                  <label className="switch" style={{marginLeft: "16px", marginRight: "8px"}}>
								                    <br />
								                    <input
								                      className="form-control"
								                      type="checkbox"
								                      name="include_published"
								                      id="preferences-include_published" 
													  onChange={this.handleChange}
													  value={this.state.preferences.include_published}
								                      checked={this.state.preferences.include_published && "checked"}
								                    />								                   
								                    <span className="slider round"></span>
								                  </label>
								                  <span className="my-0" style={{fontSize: "12px"}}>Yes</span>
								                </div>								
												{errors.date_format && (
													<div className="invalid-devtools">
														{errors.date_format
															? errors.include_published
															: ""}
													</div>
												)}
												</td>
												</tr>
												</table>
												<div className="preference-header">Appearance</div>
												<label className="my-0" style={{fontSize: "12px"}}>
													Logo:{" "}
												</label>
												<select
													className="preferences-sandbox form-control"
													onChange={this.handleChange}
													name="sandbox_type"
													value={
														this.state.preferences
															.sandbox_type
													}
													id="preferences-sandbox"
												>
													<option
														key={0}
														value={0}
														className={""}
														disabled
													>
														Select Sandbox
													</option>
													{sandboxTypeObj.map((stObj) => {
														return (
															<option
																key={stObj.type}
																value={stObj.type}
																className={""}
															>
																{stObj.name}
															</option>
														);
													})}
												</select>
										</div>										
									</div>
								);

								for (let c in preferenceTabList) {
									if (preferenceTabList[c] === "General") {
										preferenceDetailsTabs.push(
											<NavItem
												active={
													preferenceTabCounter === 0
														? "active"
														: ""
												}
												key={`${preferenceTabList[c]}-${preferenceKeyCount}-tabheader`}
												name={`${preferenceTabList[c]}-${preferenceKeyCount}`}
												value={preferenceTabList[c]}
												selected={true}
											/>
										);
	
										preferenceDetailsFields.push(
											<NavContent
												key={`${preferenceTabList[c]}-${preferenceKeyCount}-tabcontent`}
												id={`${preferenceTabList[c]}-${preferenceKeyCount}`}
												active={
													preferenceTabCounter === 0
														? "show active"
														: ""
												}
												content={
													<div className="p-2">
														{generalView}
													</div>
												}
											/>
										);
									} else {
										preferenceDetailsTabs.push(
											<NavItem
												active={
													preferenceTabCounter === 0
														? "active"
														: ""
												}
												key={`${preferenceTabList[c]}-${preferenceKeyCount}-tabheader`}
												name={`${preferenceTabList[c]}-${preferenceKeyCount}`}
												value={preferenceTabList[c]}
												selected={false}
											/>
										);
	
										preferenceDetailsFields.push(
											<NavContent
												key={`${preferenceTabList[c]}-${preferenceKeyCount}-tabcontent`}
												id={`${preferenceTabList[c]}-${preferenceKeyCount}`}
												active={
													preferenceTabCounter === 0
														? "show active"
														: ""
												}
												content={
													<div className="p-2"></div>
												}
											/>
										);
									}
	
									preferenceTabCounter++;
								}
	
								return (
									<CSSTransition
										in={true}
										appear={true}
										timeout={500}
										classNames="fade"
									>
										<div
											id="working-area-content-preferences"
											className="working-area-content-preferences"
										>
											<form onSubmit={handleSubmit}>
												<div>
													<FormButtonPanel
														endpointName="preferences"
														isFetching={isFetching}
														formType="new"
														parentUrl="/"
														allowDelete={false}
														onDelete={() => {}}
													/>
												</div>
												<div className="json-data-header">
													<ul
														className="nav nav-tabs"
														id="json-tab"
														role="tablist"
													>
														{preferenceDetailsTabs}
													</ul>
												</div>
												<div
													className="tab-content margined"
													id="generic-tab-content"
												>
													{preferenceDetailsFields}
												</div>
											</form>
										</div>
									</CSSTransition>
								);
							}}
						></Formik>
					</div>
				</div>
				)
			}else{
				return(
					<div className="container-archive">
						<div className="integration-form-overlay-archive">
						<div className="integration-form-overlay-icon">
							<i className="fa fa-circle-notch integration fa-spin fa-lg">
							{" "}
							</i>
							<div>
							<h4 style={{ color: "#1E1E1E" }}>
								Saving, please wait...
							</h4>
							</div>
						</div>
						</div>
				  </div>
				)
			}
		}else{
			return(
				<div className="container-archive">
					<div className="integration-form-overlay-archive">
						<div className="integration-form-overlay-icon">
							<i className="fa fa-circle-notch integration fa-spin fa-lg">
							{" "}
							</i>
							<div>
							<h4 style={{ color: "#1E1E1E" }}>
								Retrieving, please wait...
							</h4>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state, ownProps) {
	return {
		endpointId: ownProps && ownProps.sidebar && ownProps.sidebar.id,
		endpointName: ownProps && ownProps.sidebar && ownProps.sidebar.name,
		endpoints: state.endpoints,
		main: state.main,
		auth: state.auth,
		messageBox: state.messageBox,
		isSaving : state.loader.loading
	};
}
function mapDispatchToProps (dispatch) {
	console.log('THIS PROPS', dispatch)
	return {
		dispatch : dispatch
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreferencesForm));



// WEBPACK FOOTER //
// ./src/components/preferences/preferencesForm.js